import { WPSClient, RequestContext, APIClient } from 'DVWebNodeUtils'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import {
  getStringsInput,
  StringBundle
} from '../components/localizer/localizer'
import { getPreferencesInput } from '../utils/preferences'

export interface IStringResponse {
  stringsResponse: WpsRuntime.atv.wps.GetStringsOutputProps
  stringBundle: StringBundle
}

export interface IPreferenceResponse {
  preferencesResponse: WpsRuntime.atv.wps.GetPreferencesOutputProps
}

interface IRequestWpsData<T extends object, A extends object> {
  stringBundle?: StringBundle
  requestPreferences?: boolean
  context: RequestContext
  api: APIClient
  operation: (client: WPSClient) => Promise<T>
  additionalProps?: A
}

export const requestWpsData = async <T extends object, A extends object>({
  context,
  api,
  operation,
  stringBundle,
  requestPreferences = false,
  additionalProps
}: IRequestWpsData<T, A>) => {
  const wpsClient = new WPSClient(api)

  const [
    stringsResponse,
    preferencesResponse,
    operationResponse
  ] = await Promise.all([
    stringBundle !== undefined
      ? wpsClient.GetStrings(getStringsInput(context, stringBundle))
      : Promise.resolve(undefined),
    requestPreferences
      ? wpsClient.GetPreferences(getPreferencesInput(context))
      : Promise.resolve(undefined),
    operation(wpsClient)
  ])

  return Object.assign(
    {
      operationResponse,
      stringsResponse,
      preferencesResponse,
      stringBundle
    },
    additionalProps || {} as A
  )
}
